// Collection of maps with their names and permalinks
export const mapsCollection = [

    //Mapy WIG
    {
      "name": "Mapa WIG: Mapa Szczegółowa (1918-1947)",
      "permalink": "https://atlas.ihpan.edu.pl/pastmaps/?lon=18.648909&lat=52.505601&z=7&l=wig:1|wig25k:1"
    },
    {
      "name": "Mapa WIG: Mapa taktyczna (1918-1947)",
      "permalink": "https://atlas.ihpan.edu.pl/pastmaps/?lon=21.042501&lat=52.195036&z=6&l=wig:1|wig100k:1"
    },
    {
      "name": "Mapa WIG: Mapa operacyjna (1918-1947)",
      "permalink": "https://atlas.ihpan.edu.pl/pastmaps/?lon=18.806925&lat=52.160021&z=6.3&l=wig:1|wig300k:1"
    },
    {
      "name": "Mapa WIG: Mapa Polski i Krajów Ościennych (1939)",
      "permalink": "https://atlas.ihpan.edu.pl/pastmaps/?lon=18.494028&lat=51.922386&z=6.3&l=wig:1|wig500k1939:1"
    },
    {
      "name": "Mapa WIG: Mapa Polski i Krajów Ościennych (1947)",
      "permalink": "https://atlas.ihpan.edu.pl/pastmaps/?lon=18.943143&lat=52.331759&z=6.4&l=wig:1|wig500k:1"
    },
    //Mapy polskie
    {
      "name": "Mapa Gaula/Raczyńskiego 1:125 000 (1807-1812)",
      "permalink": "https://atlas.ihpan.edu.pl/pastmaps/?lon=16.587763&lat=52.304665&z=8.2&l=polskie:1|gaul:1"
    },
    {
      "name": "Topograficzna Karta Królestwa Polskiego (mapa Kwatermistrzostwa) 1:126 000 (1839-1843)",
      "permalink": "https://atlas.ihpan.edu.pl/pastmaps/?lon=20.996326&lat=52.693812&z=6.7&l=polskie:1|TKKP_126k:1"
    },
    {
      "name": "Karta Dawnej Polski 1:300 000 (1859)",
      "permalink": "https://atlas.ihpan.edu.pl/pastmaps/?lon=24.108587&lat=52.612911&z=5.3&l=polskie:1|chrzanowski:1"
    },

    //Mapy austriackie
    {
      "name": "Mapa administracyjna Galicji i Lodomerii autorstwa Carla Kummerer Ritter von Kummersberga (1855)",
      "permalink": "https://atlas.ihpan.edu.pl/pastmaps/?lon=20.920709&lat=49.885744&z=8.1&l=austriackie:1|kummersberg:1"
    },

    //Mapy pruskie i niemieckie
    {
      "name": "Karte von Ost-Preussen nebst Preussisch Litthauen und West-Preussen nebst dem Netzdistrict 1:150 000, (1796-1802)",
      "permalink": "https://atlas.ihpan.edu.pl/pastmaps/?lon=19.263598&lat=54.329699&z=7.1&l=pruskie_niemieckie:1|schroetter:1"
    },
    {
      "name": "Special Karte von Südpreussen... 1:150 000 (1802-1803)",
      "permalink": "https://atlas.ihpan.edu.pl/pastmaps/?lon=18.095616&lat=51.979902&z=7.5&l=pruskie_niemieckie:1|gilly:1"
    },
    {
      "name": "Topographisch - Militaerische Karte vom vormaligen Neu Ostpreussen oder dem jetziger Nördlichen Theil des Herzogthums Warschau nebst dem Russischen District (1806-1808)",
      "permalink": "https://atlas.ihpan.edu.pl/pastmaps/?lon=20.093589&lat=53.915822&z=7.1&l=pruskie_niemieckie:1|textor:1"
    },
    {
      // "name": "Reymann's Special-Karte von Central Europa, 1:200 000 (druga połowa XIX w.)",
      "name": "Special Karte von Central Europa (Reymann), 1:200 000 (druga połowa XIX w.)",
      "permalink": "https://atlas.ihpan.edu.pl/pastmaps/?lon=18.901333&lat=52.382590&z=6.5&l=pruskie_niemieckie:1|reymann:1"
    },
    {
      "name": "Niemiecka mapa topograficzna w skali 1:25 000 (tzw. Messtichblätter, 1870-1945)",
      "permalink": "https://atlas.ihpan.edu.pl/pastmaps/?lon=18.364666&lat=52.801079&z=6.2&l=pruskie_niemieckie:1|m25k:1"
    },
    {
      "name": 'Niemiecka mapa topograficzna "Karte des Deutschen Reiches" 1:100 000 (ok. 1900)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=12.476099&lat=51.885034&z=5.8&l=pruskie_niemieckie:1|kdr:1'
    },
    {
      "name": 'Niemiecka mapa topograficzna "Karte des Deutschen Reiches" 1:100 000 (ok. 1944)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=20.800534&lat=52.636871&z=5.8&l=pruskie_niemieckie:1|kdr_gb:1'
    },
    {
      "name": 'Niemiecka mapa topograficzna "Karte des Westlichen Russlands" 1:100 000 (1914-1921)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=22.445292&lat=54.154742&z=5.9&l=pruskie_niemieckie:1|kdwr:1'
    },
    {
      "name": 'Niemiecka mapa topograficzno-przeglądowa "Übersichtskarte von Mitteleuropa" 1:300 000 (ok. 1900)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=22.162255&lat=53.184139&z=5.3&l=pruskie_niemieckie:1|ukvme:1'
    },
    //Mapy rosyjskie
    {
      "name": 'Dwuwiorstówka 1:84 000 (1908-1936)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=24.157978&lat=52.431565&z=6&l=rosyjskie:1|dwuwiorstowka:1'
    },
    //Plany miast
    {
      "name": 'Plan Warszawy (1944)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=21.004817&lat=52.236979&z=11.7&l=plany_miast:1|plany_warszawy:1|warszawa:1'
    },
    {
      "name": 'Warszawa–mapa Lindleyów (1:2 500)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=21.011556&lat=52.245825&z=12.1&l=plany_miast:1|plany_warszawy:1|lindley:1'
    },
    {
      "name": 'Plan m.st Warszawy (1822)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=21.011317&lat=52.236517&z=12.7&l=plany_miast:1|plany_warszawy:1|warszawaOKI:1'
    },
    {
      "name": 'Original Plan der Vorstadt Praga (1796)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=21.032569&lat=52.256202&z=13.4&l=plany_miast:1|plany_warszawy:1|rauch:1'
    },
    {
      "name": 'Plan Warszawy [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=21.015948&lat=52.246645&z=14.1&l=plany_miast:1|plany_warszawy:1|Warszawa_nowy:1'
    },
    {
      "name": 'Plan Białegostoku (1943)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=23.161216&lat=53.131981&z=10.7&l=plany_miast:1|bialystok:1'
    },
    {
      "name": 'Plan Biecza [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=21.256689&lat=49.728159&z=15&l=plany_miast:1|Biecz_nowy:1'
    },
    {
      "name": 'Plan Bielska [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=23.200831&lat=52.768942&z=14.8&l=plany_miast:1|Bielsk_nowy:1'
    },
    {
      "name": 'Plan Brześcia [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=18.907324&lat=52.605036&z=14.9&l=plany_miast:1|Brzesc_nowy:1'
    },
    {
      "name": 'Plan Bydgoszczy (1943)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=17.994654&lat=53.127105&z=13.5&l=plany_miast:1|bydgoszcz:1'
    },
    {
      "name": 'Plan Chełmna [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=18.431679&lat=53.350575&z=14.9&l=plany_miast:1|Chelmno_nowy:1'
    },
    {
      "name": 'Plan Częstochowy (1943)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.116344&lat=50.800904&z=13.1&l=plany_miast:1|czestochowa:1'
    },
    {
      "name": 'Plan Częstochowy [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.113735&lat=50.810359&z=15&l=plany_miast:1|plany_czestochowy:1|Czestochowa_nowa:1'
    },
    {
      "name": 'Plan Dobrzynia [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.334442&lat=52.634009&z=14.9&l=plany_miast:1|Dobrzyn_nowy:1'
    },
    {
      "name": 'Plan Dolska [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=17.067860&lat=51.983981&z=14.9&l=plany_miast:1|Dolsk_nowy:1'
    },
    {
      "name": 'Plan Drohiczyna [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=22.655491&lat=52.391990&z=14.6&l=plany_miast:1|Drohiczyn_nowy:1'
    },
    {
      "name": 'Plan Elbląga [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.407981&lat=54.159875&z=14.3&l=plany_miast:1|Elblag_nowy:1'
    },
    {
      "name": 'Plan Gdańska (1944)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=18.632027&lat=54.370594&z=12.2&l=plany_miast:1|gdansk:1'
    },
    {
      "name": 'Plan Gdańska [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=18.653386&lat=54.345497&z=13.3&l=plany_miast:1|plany_gdanska:1|Gdansk_nowy:1'
    },
    {
      "name": 'Plan Gniezna [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=17.605780&lat=52.532540&z=14.4&l=plany_miast:1|Gniezno_nowy:1'
    },
    {
      "name": 'Plan Grudziądza (1943)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=18.758964&lat=53.493538&z=13.2&l=plany_miast:1|grudziadz:1'
    },
    {
      "name": 'Plan Inowrocławia (1943)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=18.248340&lat=52.803081&z=13.6&l=plany_miast:1|inowroclaw:1'
    },
    {
      "name": 'Plan Inowrocławia [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=18.267765&lat=52.794235&z=14.9&l=plany_miast:1|plany_inowroclawia:1|Inowroclaw_nowy:1'
    },
    {
      "name": 'Plan Jasła (1943)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=21.468912&lat=49.749799&z=12.7&l=plany_miast:1|jaslo:1'
    },
    {
      "name": 'Plan Kalisza [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=18.099728&lat=51.757122&z=14.4&l=plany_miast:1|Kalisz_nowy:1'
    },
    {
      "name": 'Plan Katowic (1943)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.029174&lat=50.262878&z=13.4&l=plany_miast:1|katowice:1'
    },
    {
      "name": 'Plan Kielc (1943)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=20.626465&lat=50.867693&z=13.1&l=plany_miast:1|kielce:1'
    },
    {
      "name": 'Plan Kościana (AHP XVI w.)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=16.652848&lat=52.083045&z=14.9&l=plany_miast:1|Koscian_nowy:1'
    },
    {
      "name": 'Plan Krakowa (1943)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.940610&lat=50.052242&z=12.2&l=plany_miast:1|krakow:1'
    },
    {
      "name": 'Plan Krakowa [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.954366&lat=50.059647&z=13.6&l=plany_miast:1|plany_krakowa:1|Krakow_nowy:1'
    },
    {
      "name": 'Plan Krakowa w 1598 r. [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.938292&lat=50.059847&z=15.6&l=plany_miast:1|plany_krakowa:1|Krakow1563_nowy:1'
    },
    {
      "name": 'Plan Wawelu [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.936706&lat=50.054133&z=17.3&l=plany_miast:1|plany_krakowa:1|Wawel_nowy:1'
    },
    {
      "name": 'Plan Łęczycy [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.210158&lat=52.058256&z=14.9&l=plany_miast:1|Leczyca_nowy:1'
    },
    {
      "name": 'Plan Łodzi (1943)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.428944&lat=51.770824&z=11&l=plany_miast:1|lodz:1'
    },
    {
      "name": 'Plan Lublin (1943)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=22.566514&lat=51.241181&z=12.8&l=plany_miast:1|lublin:1'
    },
    {
      "name": 'Plan Malborka [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.045347&lat=54.032717&z=14.4&l=plany_miast:1|Malbork_nowy:1'
    },
    {
      "name": 'Plan Mielnika [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=23.043820&lat=52.328608&z=14.9&l=plany_miast:1|plany_mielnika:1|Mielnik_nowy:1'
    },
    {
      "name": 'Plan Mielnika i przedmieścia krzywczyckiego [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=23.043820&lat=52.328608&z=14.9&l=plany_miast:1|plany_mielnika:1|MielnikKrzywczyce_nowy:1'
    },
    {
      "name": 'Plan Nowego Sącza [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=20.698908&lat=49.622291&z=14.6&l=plany_miast:1|NowySacz_nowy:1'
    },
    {
      "name": 'Plan Piotrkowa [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.705117&lat=51.407191&z=15.2&l=plany_miast:1|Piotrkow_nowy:1'
    },
    {
      "name": 'Plan Pleszewa [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=17.792781&lat=51.893042&z=14.9&l=plany_miast:1|Pleszew_nowy:1'
    },
    {
      "name": 'Plan Płocka [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.689412&lat=52.542487&z=15&l=plany_miast:1|Plock_nowy:1'
    },
    {
      "name": 'Plan Poznania (1943)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=16.929502&lat=52.399320&z=13&l=plany_miast:1|poznan:1'
    },
    {
      "name": 'Plan Poznania [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=16.948828&lat=52.406205&z=13.9&l=plany_miast:1|plany_poznania:1|Poznan_nowy:1'
    },
    {
      "name": 'Plan Radomia (1943)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=21.149871&lat=51.394285&z=13.3&l=plany_miast:1|radom:1'
    },
    {
      "name": 'Plan Rawy [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=20.253581&lat=51.764353&z=15.1&l=plany_miast:1|Rawa_nowy:1'
    },
    {
      "name": 'Plan Rzeszowa (1943)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=22.007926&lat=50.038836&z=13.2&l=plany_miast:1|rzeszow:1'
    },
    {
      "name": 'Plan Sandomierza [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=21.759666&lat=50.679752&z=14.7&l=plany_miast:1|Sandomierz_nowy:1'
    },
    {
      "name": 'Plan Siedlec (1943)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=22.272961&lat=52.168030&z=13.3&l=plany_miast:1|siedlce:1'
    },
    {
      "name": 'Plan Sieradza [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=18.749036&lat=51.593161&z=15.1&l=plany_miast:1|Sieradz_nowy:1'
    },
    {
      "name": 'Plan Siewierza [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.244752&lat=50.467080&z=15&l=plany_miast:1|Siewierz_nowy:1'
    },
    {
      "name": 'Plan Tarnowa (1943)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=20.996365&lat=50.015052&z=13.6&l=plany_miast:1|tarnow:1'
    },
    {
      "name": 'Plan Torunia (1943)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=18.604753&lat=53.015292&z=12.8&l=plany_miast:1|torun:1'
    },
    {
      "name": 'Plan Węgrowa [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=22.022985&lat=52.395773&z=14.9&l=plany_miast:1|Wegrow_nowy:1'
    },
    {
      "name": 'Plan Wieliczki [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=20.067518&lat=49.980081&z=14.8&l=plany_miast:1|Wieliczka_nowy:1'
    },
    {
      "name": 'Plan Wielunia [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=18.577407&lat=51.219970&z=15.2&l=plany_miast:1|Wielun_nowy:1'
    },
    {
      "name": 'Plan Włocławka [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.071251&lat=52.652891&z=14.4&l=plany_miast:1|Wloclawek_nowy:1'
    },
    {
      "name": 'Plan Wrocławia (1944)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=17.035570&lat=51.107642&z=13&l=plany_miast:1|wroclaw:1'
    },
    {
      "name": 'Plan Wschowy [AHP XVI w.]',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=16.330423&lat=51.802816&z=14.9&l=plany_miast:1|Wschowa_nowy:1'
    },
    //Mapy historyczne
    //Atlas historyczny polski
    {
      "name": 'Ziemie polskie Korony w drugiej połowie XVI wieku. Mapa w skali 1:250 000',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=18.385640&lat=52.262408&z=6.4&l=historyczne:1|ahp:1|ahp_ziemie_polskie:1'
    },
    {
      "name": 'Podziały kościelne ziem polskich Korony',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.021539&lat=52.020479&z=6.4&l=historyczne:1|ahp:1|ahp_koscielne:1'
    },
    {
      "name": 'Rozmieszczenie własności ziemskiej ziem polskich Korony',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.035602&lat=52.350262&z=6.4&l=historyczne:1|ahp:1|ahp_wlasnosc:1'
    },
    {
      "name": 'Ważniejsze drogi ziem polskich Korony',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=17.990434&lat=52.099756&z=6.4&l=historyczne:1|ahp:1|ahp_drogi:1'
    },
    {
      "name": 'Mapa województwa krakowskiego z doby Sejmu Czteroletniego (1788-1792)',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=19.458841&lat=50.528404&z=8.6&l=historyczne:1|ahp18w:1|krakowskie18w:1'
    },
    {
      "name": 'Śląsk w końcu XVIII wieku',
      "permalink": 'https://atlas.ihpan.edu.pl/pastmaps/?lon=16.315217&lat=51.206818&z=7.6&l=historyczne:1|ahp18w:1|slask18w:1'
    },
]